export const ERROR_DATA_KEY = '$errorData';
export const LOGIN_REDIRECT_PARAM = 'return_to';
export const PROD_SEND_BUILDER_FEEDBACK_FLOW_HASH_ID = 'O3m5oO35';
export const TEST_MODE_QUERY_PARAM = 'test';
